import * as t from "io-ts"

const PublishDevicePostBodyPartial = t.intersection([
    t.type({
        DeviceID: t.string,
        DeviceRef: t.string,
        ModelNo: t.string,
        DeviceCategoryID: t.number,
        DeviceTypeID: t.number,
        RegisteredCapacity: t.number,
        SoftwareVersion: t.string,
        HardwareVersion: t.string,
        DeviceComments: t.string,
        PhaseID: t.number,
    }),
    t.partial({
        ManufacturerID: t.number,
    }),
])

const NewVersionResponsePartial = t.type({
    ManufacturerID: t.number,
    DeviceID: t.string,
    DeviceRef: t.string,
    ModelNo: t.string,
    DeviceCategoryID: t.number,
    DeviceTypeID: t.number,
    RegisteredCapacity: t.number,
    SoftwareVersion: t.string,
    HardwareVersion: t.string,
    DeviceComments: t.string,
    PhaseID: t.number,
})

const NewAmendmentResponsePartial = t.type({
    DeviceID: t.string,
    DeviceRef: t.string,
    ManufacturerID: t.number,
    ModelNo: t.string,
    DeviceCategoryID: t.number,
    DeviceTypeID: t.number,
    RegisteredCapacity: t.number,
    SoftwareVersion: t.string,
    HardwareVersion: t.string,
    DeviceComments: t.string,
    PhaseID: t.number,
    AttachmentUUID: t.string,
})

const NewAmendmentPostBodyPartial = t.type({
    DeviceID: t.string,
    DeviceRef: t.string,
    ManufacturerID: t.number,
    ModelNo: t.string,
    DeviceCategoryID: t.number,
    DeviceTypeID: t.number,
    RegisteredCapacity: t.number,
    SoftwareVersion: t.string,
    HardwareVersion: t.string,
    DeviceComments: t.string,
    PhaseID: t.number,
    AttachmentUUID: t.string,
})

const SaveDeviceDraftPostBodyPartial = t.partial({
    DeviceID: t.string,
    DeviceRef: t.string,
    ManufacturerID: t.number,
    ModelNo: t.string,
    DeviceCategoryID: t.number,
    DeviceTypeID: t.number,
    RegisteredCapacity: t.number,
    SoftwareVersion: t.string,
    HardwareVersion: t.string,
    DeviceComments: t.string,
    PhaseID: t.number,
    AttachmentUUID: t.string,
    SupersededDeviceID: t.number,
    ComplianceStatusNotes: t.string,
    ComplianceComments: t.string,
})

const ContinueDraftResponsePartial = t.type({
    DeviceID: t.union([t.string, t.null]),
    DeviceRef: t.union([t.string, t.null]),
    ManufacturerID: t.union([t.number, t.null]),
    ModelNo: t.union([t.string, t.null]),
    DeviceCategoryID: t.union([t.number, t.null]),
    DeviceTypeID: t.union([t.number, t.null]),
    RegisteredCapacity: t.union([t.number, t.null]),
    SoftwareVersion: t.union([t.string, t.null]),
    HardwareVersion: t.union([t.string, t.null]),
    DeviceComments: t.union([t.string, t.null]),
    PhaseID: t.union([t.number, t.null]),
    Attachment_UUID: t.union([t.string, t.null]),
    SupersededDeviceID: t.union([t.number, t.null]),
    ComplianceStatusNotes: t.union([t.string, t.null]),
    ComplianceComments: t.union([t.string, t.null]),
    RecordDate: t.union([t.string, t.null]),
    PublishedDate: t.union([t.string, t.null]),
    ComplianceStatus: t.union([t.number, t.null]),
})

const TypeTestPostBodyStandardName = t.union([
    t.literal("PTT_G98"),
    t.literal("FTT_G98"),
    t.literal("PTT_G98_NI"),
    t.literal("FTT_G98_NI"),
    t.literal("PTT_G99A"),
    t.literal("FTT_G99A"),
    t.literal("PTT_G99A_NI"),
    t.literal("FTT_G99A_NI"),
    t.literal("PTT_G99B"),
    t.literal("FTT_G99B"),
    t.literal("PTT_G99B_NI"),
    t.literal("FTT_G99B_NI"),
    t.literal("PTT_G99C"),
    t.literal("FTT_G99C"),
    t.literal("PTT_G99C_NI"),
    t.literal("FTT_G99C_NI"),
    t.literal("PTT_G99D"),
    t.literal("FTT_G99D"),
    t.literal("PTT_G99D_NI"),
    t.literal("FTT_G99D_NI"),
    t.literal("PTT_G100"),
    t.literal("FTT_G100"),
    t.literal("PTT_G100_NI"),
    t.literal("FTT_G100_NI"),
])

const TypeTestPostBody = t.record(
    TypeTestPostBodyStandardName,
    t.union([t.literal("Y"), t.literal("N")])
)

const TypeTestVersionPostBody = t.partial({
    G98GBVersion: t.union([t.number, t.null]),
    G99GBVersion: t.union([t.number, t.null]),
    G98NIVersion: t.union([t.number, t.null]),
    G99NIVersion: t.union([t.number, t.null]),
})

const PublishDevicePostBody = t.intersection([
    PublishDevicePostBodyPartial,
    TypeTestPostBody,
])

export const NewVersionResponse = t.intersection([
    NewVersionResponsePartial,
    TypeTestPostBody,
])

export const NewAmendmentResponse = t.intersection([
    NewAmendmentResponsePartial,
    TypeTestPostBody,
])

export const NewAmendmentPostBody = t.intersection([
    NewAmendmentPostBodyPartial,
    TypeTestPostBody,
])

export const SaveDeviceDraftPostBody = t.intersection([
    SaveDeviceDraftPostBodyPartial,
    TypeTestVersionPostBody,
    TypeTestPostBody,
])

export const ContinueDraftResponse = t.intersection([
    ContinueDraftResponsePartial,
    TypeTestVersionPostBody,
    TypeTestPostBody,
])

export const PublishAmendmentResponse = t.type({
    published_device_id: t.string,
    amendment_ref: t.string,
})

export type TTypeTestPostBodyStandardName = t.TypeOf<
    typeof TypeTestPostBodyStandardName
>

export type TTypeTestPostBody = t.TypeOf<typeof TypeTestPostBody>

export type TPublishDevicePostBodyPartial = t.TypeOf<
    typeof PublishDevicePostBodyPartial
>

export type TPublishDevicePostBody = t.TypeOf<typeof PublishDevicePostBody>

export type TNewVersionResponse = t.TypeOf<typeof NewVersionResponse>

export type TNewAmendmentResponse = t.TypeOf<typeof NewAmendmentResponse>

export type TNewAmendmentPostBodyPartial = t.TypeOf<
    typeof NewAmendmentPostBodyPartial
>

export type TNewAmendmentPostBody = t.TypeOf<typeof NewAmendmentPostBody>

export type TSaveDeviceDraftPostBodyPartial = t.TypeOf<
    typeof SaveDeviceDraftPostBodyPartial
>

export type TSaveDeviceDraftPostBody = t.TypeOf<typeof SaveDeviceDraftPostBody>

export type TContinueDraftResponse = t.TypeOf<typeof ContinueDraftResponse>

export type TTypeTestVersionPostBody = t.TypeOf<typeof TypeTestVersionPostBody>

export type TTTRDeviceResponseType =
    | TNewVersionResponse
    | TContinueDraftResponse
    | TNewAmendmentResponse

export type TPublishAmendmentResponse = t.TypeOf<
    typeof PublishAmendmentResponse
>

export const CreateDraftDeviceAPIResponse = t.type({
    SystemReference: t.string,
    Status: t.string,
})
